import * as externalStoreConfig from '/src/features/external-forms/store';

/**
 * Middleware to load platform details and available languages for tenant
 */
export default async function (to) {
  const route = to;
  const nuxtApp = useNuxtApp();
  const store = nuxtApp.$store;

  // If middleware is called from hot module replacement, ignore it
  if (!route.path.startsWith('/form')) return;
  if (!store.state['external-forms']) {
    store.registerModule('external-forms', externalStoreConfig);
  }

  await Promise.all([
    store.dispatch('external-forms/getPlatformDetails', route.params.tenantEntryUUID),
    store.dispatch('external-forms/getAvailableLanguages', route.params.tenantEntryUUID)
  ]);
}
